import React, { FC } from 'react';
import { Box, styled } from '@mui/material';
import ListingsCategoryFilters from './ListingsCategoryFilters';
import { Filters } from './types';
import { ListingsSummary } from '../../graphql/generated';

interface ListingsToolbarProps {
  onFiltersSubmit: (filters: Filters) => void;
  listingsSummary: ListingsSummary;
}

const ToolbarContainer = styled(Box)(({ theme }) => ({
  position: 'sticky',
  top: 64,
  zIndex: 1000,
  backgroundColor: theme.palette.background.paper,
  // borderBottom: '1px solid #d3d3d3',
  padding: theme.spacing(2),
  display: 'flex',
  borderRadius: '16px',
  alignItems: 'center',  // Aligns items vertically in the center
  justifyContent: 'space-between',  // Adjusts space between the items
  flexWrap: 'nowrap',  // Prevents wrapping of elements to multiple lines
}));

const ListingsToolbar: FC<ListingsToolbarProps> = ({ onFiltersSubmit, listingsSummary }) => (
  <ToolbarContainer gap={2}>
    <ListingsCategoryFilters onFiltersSubmit={onFiltersSubmit} listingsSummary={listingsSummary} />
  </ToolbarContainer>
);

export default ListingsToolbar;
